import { isSnapshotUsable, readSnapshot } from "./offlineSession";

const OFFLINE_SESSION_KEY = "offline_session";

// Which enrolment is running offline on this machine. localStorage rather than
// the encrypted store, because the point of it is to be shared: every desktop
// screen reads the same origin, which is how one screen learns what another
// one did. It holds a cognitoSub and nothing secret — the permissions it
// stands for stay behind safeStorage.
export function setOfflineMarker(cognitoSub: string): void {
  try {
    localStorage.setItem(OFFLINE_SESSION_KEY, cognitoSub);
  } catch {
    /* storage may be disabled */
  }
}

export function getOfflineMarker(): string | null {
  try {
    return localStorage.getItem(OFFLINE_SESSION_KEY);
  } catch {
    return null;
  }
}

export function clearOfflineMarker(): void {
  try {
    localStorage.removeItem(OFFLINE_SESSION_KEY);
  } catch {
    /* ignore */
  }
}

// Offline, a screen that just signed in and a screen that just signed out
// broadcast the same event and both fail a forceRefresh, so cognito cannot
// separate them. The marker can: an offline login writes it and every teardown
// clears it, without a round trip either way. The snapshot is still consulted,
// so a marker left behind by a crash cannot resurrect an expired enrolment.
export async function hasMarkedOfflineSession(
  now: number = Date.now(),
): Promise<boolean> {
  const cognitoSub = getOfflineMarker();
  if (!cognitoSub) return false;
  const snapshot = await readSnapshot(cognitoSub);
  return !!snapshot && isSnapshotUsable(snapshot, now);
}
